const StepUpAffiliationSection = () => {
  return (
    <section
      aria-label="Step Up For Students provider information"
      className="relative overflow-hidden bg-white py-8 sm:py-10 md:py-12"
    >
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-gray-50/80" aria-hidden="true" />
      <div className="container relative mx-auto px-4">
        <a
          href="/page/step-up-for-students"
          aria-label="Learn how Step Up For Students scholarships can be used at Owaza Martial Arts"
          className="group mx-auto block max-w-xl focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-red-600/40 focus-visible:ring-offset-4"
        >
          <img
            src="/owaza-step-up-provider-v2.webp"
            alt="Owaza Martial Arts is an authorized Step Up For Students provider for martial arts, wellness, fitness classes, and martial arts supplies. Florida families may use Step Up scholarship funds toward training."
            className="h-auto w-full rounded-[1.75rem] shadow-[0_24px_70px_-28px_rgba(17,24,39,0.4)] ring-1 ring-gray-200 transition duration-300 group-hover:-translate-y-1 group-hover:shadow-[0_30px_80px_-28px_rgba(17,24,39,0.48)] motion-reduce:transform-none motion-reduce:transition-none"
            width="1188"
            height="1324"
            loading="eager"
          />
          <span className="sr-only">Learn how it works</span>
        </a>
      </div>
    </section>
  );
};

export default StepUpAffiliationSection;
